import { useQuery } from "@tanstack/react-query";
import { QA_API_DOMAIN, fetchWithSupabaseAuth } from "@/api/classifier";

export interface ProcessedDocument {
  id: string;
  fileIdentifier: "endoscopy_procedure" | "endoscopy_histology" | "codeable_summary";
  fileDate: string;
  title: string;
  text: string;
}

export interface ProcessedDocumentsResult {
  documents: ProcessedDocument[];
  failedCount: number;
}

async function fetchProcessedDocumentsForEncounter(encounterId: string): Promise<ProcessedDocumentsResult> {
  const res = await fetchWithSupabaseAuth(
    `${QA_API_DOMAIN}/raw-files-viewer/encounter/${encounterId}/processed-documents`,
  );

  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: string };
    throw new Error(body.error ?? `Failed to fetch processed documents (${res.status})`);
  }

  return (await res.json()) as ProcessedDocumentsResult;
}

export function useProcessedDocumentsForEncounter(encounterId: string | null) {
  return useQuery({
    queryKey: ["raw-files-viewer-processed-documents", encounterId],
    queryFn: () => fetchProcessedDocumentsForEncounter(encounterId!),
    enabled: !!encounterId,
  });
}
